window.infotp2formulaeditor_left = function () {
    var ti_Icon = '<svg class="svgicon-askue_ti"><use xlink:href="/data/icons/svg#icon-askue_ti"></use></svg>';
    var cti_Icon = '<svg class="svgicon-askue_contr_ti"><use xlink:href="/data/icons/svg#icon-askue_contr_ti"></use></svg>';
    var function_Icon = '<svg class="svgicon-function"><use xlink:href="/data/icons/svg#icon-function"></use></svg>';
    var calc_Icon = '<svg class="svgicon-calc"><use xlink:href="/data/icons/svg#icon-calc"></use></svg>';
    var ti_Icon_mtp = '<svg class="svgicon-askue_contr_ti"><use xlink:href="/data/icons/svg#icon-askue_oti"></use></svg>';
    var cti_Icon_mtp = '<svg class="svgicon-askue_contr_ti"><use xlink:href="/data/icons/svg#icon-askue_oti_ka"></use></svg>';
    
    var TI_FSC = 'ТИ ФСК: ';
    var TI_KA = 'ТИ КА: ';
    var Formula = 'Формула: ';
    
    var IsContractsData = 'Контракт: ';
    var IsContractClauseData = 'Пункт контракта: ';

    var SectionEI = 'Сечение ЭИ: ';
    var SectionEIData = 'Данные сечения ЭИ: ';

    var instance = {

        //Help Function
        ClearAttributes: function (elem) {
            console.log('Clear attributes');
            //Data editor attributes
            elem.removeAttribute('attrdescr-tiid');
            elem.removeAttribute('attrdescr-contrtiid');
            elem.removeAttribute('attrdescr-formula_un');
            elem.removeAttribute('attrdescr-channel');
            elem.removeAttribute('attrdescr-iscontractclause');
            elem.removeAttribute('attrdescr-iscontract');
            elem.removeAttribute('attrdescr-sectionid');
            elem.removeAttribute('attrdescr-sectiondataid');            
            
            //Template attributes
            elem.removeAttribute('attrdescr-template');
        },

        splitFormulaInfo: function (info) {
            var separatorIndex = info.lastIndexOf('__');
            return [info.substring(0, separatorIndex), info.substring(separatorIndex + 2)];
        },

        //TP------------------------------------------------------------------------------------------------------------------
        setonclicks_ti: function () {
            //var _this = this;
            //_this.infotp2formulaeditor = new infotp2formulaeditor();
             document.querySelectorAll("a[data-ot-ti-setClick='false']").forEach(function (a) {
                 var arg = a.getAttribute('data-addti');

                 a.addEventListener("click", function (event) {
                     window.infotp2formulaeditor_left.addti(arg = '' ? null : arg, event.target);
                });
                a.setAttribute("data-ot-ti-setClick", "true");
            });
        },
        setonclicks_cti: function () {
            //var _this = this;
            //_this.infotp2formulaeditor = new infotp2formulaeditor();
            document.querySelectorAll("a[data-ot-cti-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addcti');
                console.log(arg);
                a.addEventListener("click", function (event) {
                    window.infotp2formulaeditor_left.addcti(arg = '' ? null : arg, event.target);
                });
                a.setAttribute("data-ot-cti-setClick", "true");
            });
        },
        setonclicks_form: function () {
            //var _this = this;
            //_this.infotp2formulaeditor = new infotp2formulaeditor();
            document.querySelectorAll("a[data-ot-form-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addform');
                var dim = a.getAttribute('data-dim');
                a.addEventListener("click", function () {
                    //_this.infotp2formulaeditor.addform(arg = '' ? null : arg);
                    var formula_dim = document.querySelector("select[name='dimension']").value;
                    if (formula_dim != dim) {
                        const d = document.getElementById("okdialog");
                        const s = document.getElementById("contentspan");
                        s.innerHTML = 'Объект ' + window.infotp2formulaeditor_left.splitFormulaInfo(arg)[0] + ' не может быть добавлен в формулу, размерности добавляемой и редактируемой формул различаются';
                        dialog.open(d);
                        return;
					}
                    window.infotp2formulaeditor_left.addform(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-form-setClick", "true");
            });
        },

        //Section------------------------------------------------------------------------------------------------------------------
        setonclicks_contr_clause: function () {
            console.log('setonclicks_contr_clause');
            //var _this = this;
            //_this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-cl-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addclausecontract');
                a.addEventListener("click", function () {
                    //_this.sectioneiformulaeditor.addclausecontract(arg = '' ? null : arg);
                    window.infotp2formulaeditor_left.addclausecontract(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-cl-setClick", "true");
            });

        },
        setonclicks_contr: function () {
            //console.log('setonclicks_contr');
            //var _this = this;
            //_this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-ctr-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addcontract');
                a.addEventListener("click", function () {
                    //_this.sectioneiformulaeditor.addcontract(arg = '' ? null : arg);
                    window.infotp2formulaeditor_left.addcontract(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-ctr-setClick", "true");
            });
        },

        setonclicks_sectionei: function () {
            console.log('setonclicks_sectionei');
            //var _this = this;
            //_this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-ctr-ei-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-addsectionei');
                a.addEventListener("click", function () {
                    //_this.sectioneiformulaeditor.addsectionei(arg = '' ? null : arg);
                    window.infotp2formulaeditor_left.addsectionei(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-ctr-ei-setClick", "true");
            });
        },
        setonclicks_sectiondataei: function () {
            console.log('setonclicks_sectiondataei');
            //var _this = this;
            //_this.sectioneiformulaeditor = new sectioneiformulaeditor();
            document.querySelectorAll("a[data-ot-ctr-dataei-setClick='false']").forEach(function (a) {
                var arg = a.getAttribute('data-adddatasectionei');
                a.addEventListener("click", function () {
                    //_this.sectioneiformulaeditor.adddatasectionei(arg = '' ? null : arg);
                    window.infotp2formulaeditor_left.adddatasectionei(arg = '' ? null : arg);
                });
                a.setAttribute("data-ot-ctr-dataei-setClick", "true");
            });
        },



        addti(info, el) {
            try {
                var newrow = null;
                if (document.querySelectorAll("tr[selectinserted]").length == 0) {
                    var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
                    newrow = table.infotp2formulaeditor.addrowdown(table.firstChild.lastChild);
                    newrow.setAttribute("selectinserted", "true");
                }
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = info.split('|');

                    var iconObject = tr.querySelector("i[attricon_askue]");
                    if (iconObject != null) {
                        iconObject.innerHTML = el.closest('td').querySelector('i').outerHTML;
                    }
                    iconObject.parentNode.replaceChild(iconObject.cloneNode(true), iconObject);

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");
                        var typeName = '';// (text[4] == '1' ? 'О' : '') + TI_FSC;

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = text[4] == '1' ? ti_Icon_mtp : ti_Icon;
                                    }

                                    var templateAtrChannel = elem.getAttribute('attrdescr-template-channel');
                                    var templateAtrChannelName = elem.getAttribute('attrdescr-template-channel-name');

                                    elem.innerHTML = typeName + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                    window.infotp2formulaeditor_left.ClearAttributes(elem);
                                    /*
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');

                                    elem.removeAttribute('attrdescr-template');
                                    */
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";


                                    elem.setAttribute('attrdescr-tiid', text[1]);
                                    elem.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");
                                var templateAtrChannel = spansTemplate.getAttribute('attrdescr-template-channel');
                                var templateAtrChannelName = spansTemplate.getAttribute('attrdescr-template-channel-name');

                                spansTemplate.innerHTML = typeName + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                window.infotp2formulaeditor_left.ClearAttributes(spansTemplate);
                                /*
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                */
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spansTemplate.setAttribute('attrdescr-tiid', text[1]);
                                spansTemplate.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));

                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = typeName + text[0] + ', ' + text[3];
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-contrtiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                spanObject.setAttribute('attrdescr-tiid', text[1]);
                                spanObject.setAttribute('attrdescr-channel', text[2]);
                            }
                        }
                    }
                    if (newrow)
                        newrow.removeAttribute("selectinserted");
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },
        addcti(info, el) {
            try {
                var newrow = null;
                if (document.querySelectorAll("tr[selectinserted]").length == 0) {
                    var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
                    newrow = table.infotp2formulaeditor.addrowdown(table.firstChild.lastChild);
                    newrow.setAttribute("selectinserted", "true");
                }
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = info.split('|');

                    var iconObject = tr.querySelector("i[attricon_askue]");
                    if (iconObject != null) {
                        iconObject.innerHTML = el.closest('td').querySelector('i').outerHTML;
                    }
                    iconObject.parentNode.replaceChild(iconObject.cloneNode(true), iconObject);

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");
                        var typeName = '';// (text[4] == '1' ? 'О' : '') + TI_KA;

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = text[4] == '1' ? cti_Icon_mtp : cti_Icon;
                                    }

                                    var templateAtrChannel = elem.getAttribute('attrdescr-template-channel');
                                    var templateAtrChannelName = elem.getAttribute('attrdescr-template-channel-name');

                                    elem.innerHTML = typeName + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');

                                    elem.removeAttribute('attrdescr-template');
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";

                                    spanObject.setAttribute('attrdescr-contrtiid', text[1]);
                                    elem.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");
                                var templateAtrChannel = spansTemplate.getAttribute('attrdescr-template-channel');
                                var templateAtrChannelName = spansTemplate.getAttribute('attrdescr-template-channel-name');

                                spansTemplate.innerHTML = typeName + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spanObject.setAttribute('attrdescr-contrtiid', text[1]);
                                spansTemplate.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));

                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = typeName + text[0] + ', ' + text[3];
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                spanObject.setAttribute('attrdescr-contrtiid', text[1]);
                                spanObject.setAttribute('attrdescr-channel', text[2]);
                            }
                        }
                    }
                    if (newrow)
                        newrow.removeAttribute("selectinserted");
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },            
        addform(info) {
            //ToDo пока уберем вывод по каналам
            /*
            document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                var text = info.split('__');

                var iconObject = tr.querySelector("i[attricon_askue]");
                if (iconObject != null) {
                    iconObject.innerHTML = function_Icon;
                }

                var spanObject = tr.querySelector("span[data-objectlabel]");
                if (spanObject != null) {
                    spanObject.innerHTML = 'Формула: ' + text[0];// + ', ' + text[3];
                    spanObject.removeAttribute('attrdescr-tiid');
                    spanObject.removeAttribute('attrdescr-contrtiid');
                    spanObject.removeAttribute('attrdescr-formula_un');
                    spanObject.removeAttribute('attrdescr-channel');
                    spanObject.setAttribute('attrdescr-formula_un', text[1]);
                    //spanObject.setAttribute('attrdescr-channel', text[3]);
                }
            });
            this.onChangeFormula();
            */
            try {
                var newrow = null;
                if (document.querySelectorAll("tr[selectinserted]").length == 0) {
                    var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
                    newrow = table.infotp2formulaeditor.addrowdown(table.firstChild.lastChild);
                    newrow.setAttribute("selectinserted", "true");
				}
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = window.infotp2formulaeditor_left.splitFormulaInfo(info);

                    var iconObject = tr.querySelector("i[attricon_askue]");
                    if (iconObject != null) {
                        iconObject.innerHTML = function_Icon;
                        iconObject.removeAttribute("style");
                        iconObject.removeAttribute("title");
                    }
                    iconObject.parentNode.replaceChild(iconObject.cloneNode(true), iconObject);

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = function_Icon;
                                    }

                                    elem.innerHTML = Formula + text[0];
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');

                                    elem.removeAttribute('attrdescr-template');
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";

                                    elem.setAttribute('attrdescr-formula_un', text[1]);
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");

                                spansTemplate.innerHTML = Formula + text[0];
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spansTemplate.setAttribute('attrdescr-formula_un', text[1]);
                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = Formula + text[0];
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-contrtiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                spanObject.setAttribute('attrdescr-formula_un', text[1]);
                            }
                        }
                    }
                    if (newrow)
                        newrow.removeAttribute("selectinserted");
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },

        addcontract(info) {
            try {
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = info.split('|');

                    var iconObject = tr.querySelector("i[attricon_calc]");
                    if (iconObject != null) {
                        iconObject.innerHTML = calc_Icon;
                    }

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = ti_Icon;
                                    }

                                    //var templateAtrChannel = elem.getAttribute('attrdescr-template-channel');
                                    //var templateAtrChannelName = elem.getAttribute('attrdescr-template-channel-name');

                                    elem.innerHTML = IsContractsData + text[0];// + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                    window.infotp2formulaeditor_left.ClearAttributes(elem);
                                    /*
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');
                                    elem.removeAttribute('attrdescr-iscontract');

                                    elem.removeAttribute('attrdescr-template');
                                    */
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";

                                    elem.setAttribute('attrdescr-iscontract', text[1]);
                                    //elem.setAttribute('attrdescr-tiid', text[1]);
                                    //elem.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");
                                //var templateAtrChannel = spansTemplate.getAttribute('attrdescr-template-channel');
                                //var templateAtrChannelName = spansTemplate.getAttribute('attrdescr-template-channel-name');

                                spansTemplate.innerHTML = IsContractsData + text[0];// + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                window.infotp2formulaeditor_left.ClearAttributes(spansTemplate);
                                /*
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                */
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spansTemplate.setAttribute('attrdescr-iscontract', text[1]);
                                //spansTemplate.setAttribute('attrdescr-tiid', text[1]);
                                //spansTemplate.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));

                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = IsContractsData + text[0];// + ', ' + text[3];
                                window.infotp2formulaeditor_left.ClearAttributes(spanObject);
                                /*
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-contrtiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                */

                                spanObject.setAttribute('attrdescr-iscontract', text[1]);
                                //spanObject.setAttribute('attrdescr-tiid', text[1]);
                                //spanObject.setAttribute('attrdescr-channel', text[2]);
                            }
                        }
                    }
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },

        addclausecontract(info) {
            try {
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = info.split('|');

                    var iconObject = tr.querySelector("i[attricon_askue]");
                    if (iconObject != null) {
                        iconObject.innerHTML = ti_Icon;
                    }

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = ti_Icon;
                                    }

                                    var templateAtrChannel = elem.getAttribute('attrdescr-template-channel');
                                    var templateAtrChannelName = elem.getAttribute('attrdescr-template-channel-name');

                                    elem.innerHTML = IsContractClauseData + text[0];// + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                    window.infotp2formulaeditor_left.ClearAttributes(elem);
                                    /*
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');
                                    elem.removeAttribute('attrdescr-iscontract');

                                    elem.removeAttribute('attrdescr-template');
                                    */
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";


                                    elem.setAttribute('attrdescr-iscontractclause', text[1]);
                                    elem.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");
                                var templateAtrChannel = spansTemplate.getAttribute('attrdescr-template-channel');
                                var templateAtrChannelName = spansTemplate.getAttribute('attrdescr-template-channel-name');

                                spansTemplate.innerHTML = IsContractClauseData + text[0];// + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                window.infotp2formulaeditor_left.ClearAttributes(spansTemplate);
                                /*
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                */
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spansTemplate.setAttribute('attrdescr-iscontractclause', text[1]);
                                spansTemplate.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));

                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = IsContractClauseData + text[0];// + ', ' + text[3];
                                window.infotp2formulaeditor_left.ClearAttributes(spanObject);
                                /*
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-contrtiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                */
                                spanObject.setAttribute('attrdescr-iscontractclause', text[1]);
                                spanObject.setAttribute('attrdescr-channel', text[2]);
                            }
                        }
                    }
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },

        addsectionei(info) {
            try {
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = info.split('|');

                    var iconObject = tr.querySelector("i[attricon_askue]");
                    if (iconObject != null) {
                        iconObject.innerHTML = ti_Icon;
                    }

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = ti_Icon;
                                    }

                                    var templateAtrChannel = elem.getAttribute('attrdescr-template-channel');
                                    var templateAtrChannelName = elem.getAttribute('attrdescr-template-channel-name');

                                    elem.innerHTML = SectionEI + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                    window.infotp2formulaeditor_left.ClearAttributes(elem);
                                    /*
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');
                                    elem.removeAttribute('attrdescr-iscontract');

                                    elem.removeAttribute('attrdescr-template');
                                    */
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";


                                    elem.setAttribute('attrdescr-sectionid', text[1]);
                                    elem.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");
                                var templateAtrChannel = spansTemplate.getAttribute('attrdescr-template-channel');
                                var templateAtrChannelName = spansTemplate.getAttribute('attrdescr-template-channel-name');

                                spansTemplate.innerHTML = SectionEI + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                window.infotp2formulaeditor_left.ClearAttributes(spansTemplate);
                                /*
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                */
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spansTemplate.setAttribute('attrdescr-sectionid', text[1]);
                                spansTemplate.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));

                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = SectionEI + text[0];// + ', ' + text[3];
                                window.infotp2formulaeditor_left.ClearAttributes(spanObject);
                                /*
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-contrtiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                */
                                spanObject.setAttribute('attrdescr-sectionid', text[1]);
                                spanObject.setAttribute('attrdescr-channel', text[2]);
                            }
                        }
                    }
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },

        adddatasectionei(info) {
            try {
                document.querySelectorAll("tr[selectinserted]").forEach(function (tr) {
                    var text = info.split('|');

                    var iconObject = tr.querySelector("i[attricon_askue]");
                    if (iconObject != null) {
                        iconObject.innerHTML = ti_Icon;
                    }

                    var spanObject = tr.querySelector("span[data-objectlabel]");
                    if (spanObject != null) {

                        //Check soft template
                        var softTemplate = document.querySelector("input[name='issofttemplate'][class*='active']");

                        //Check is template
                        var templateAtr = spanObject.getAttribute('attrdescr-template');
                        if (templateAtr != null) {
                            var tableWork = document.querySelector("table[id*='tabsright_tformulaviewtexttab']");

                            var softTemplateInput = document.querySelector("input[name='issofttemplate']");
                            softTemplateInput.disabled = true;

                            if (softTemplate == null) {
                                var spansTemplate = tableWork.querySelectorAll("span[attrdescr-template='" + templateAtr + "']");
                                spansTemplate.forEach(function (elem, index, arr) {

                                    var iconObjectTemplate = elem.parentNode.querySelector("i[attricon_askue]");
                                    if (iconObjectTemplate != null) {
                                        iconObjectTemplate.innerHTML = ti_Icon;
                                    }

                                    var templateAtrChannel = elem.getAttribute('attrdescr-template-channel');
                                    var templateAtrChannelName = elem.getAttribute('attrdescr-template-channel-name');

                                    elem.innerHTML = SectionEIData + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                    window.infotp2formulaeditor_left.ClearAttributes(elem);
                                    /*
                                    elem.removeAttribute('attrdescr-tiid');
                                    elem.removeAttribute('attrdescr-contrtiid');
                                    elem.removeAttribute('attrdescr-formula_un');
                                    elem.removeAttribute('attrdescr-channel');
                                    elem.removeAttribute('attrdescr-iscontract');

                                    elem.removeAttribute('attrdescr-template');
                                    */
                                    elem.parentNode.style.backgroundColor = "";
                                    elem.style.fontWeight = "";


                                    elem.setAttribute('attrdescr-sectiondataid', text[1]);
                                    elem.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));
                                });
                            }
                            else {

                                var spansTemplate = tr.querySelector("span[attrdescr-template='" + templateAtr + "']");
                                var templateAtrChannel = spansTemplate.getAttribute('attrdescr-template-channel');
                                var templateAtrChannelName = spansTemplate.getAttribute('attrdescr-template-channel-name');

                                spansTemplate.innerHTML = SectionEIData + text[0] + ', ' + ((templateAtrChannelName != undefined && templateAtrChannelName != '') ? templateAtrChannelName : text[3]);
                                window.infotp2formulaeditor_left.ClearAttributes(spansTemplate);
                                /*
                                spansTemplate.removeAttribute('attrdescr-tiid');
                                spansTemplate.removeAttribute('attrdescr-contrtiid');
                                spansTemplate.removeAttribute('attrdescr-formula_un');
                                spansTemplate.removeAttribute('attrdescr-channel');

                                spansTemplate.removeAttribute('attrdescr-template');
                                */
                                spansTemplate.parentNode.style.backgroundColor = "";
                                spansTemplate.style.fontWeight = "";

                                spansTemplate.setAttribute('attrdescr-sectiondataid', text[1]);
                                spansTemplate.setAttribute('attrdescr-channel', ((templateAtrChannel != undefined && templateAtrChannel != '') ? templateAtrChannel : text[2]));

                            }

                        }
                        else {
                            var spanObject = tr.querySelector("span[data-objectlabel]");
                            if (spanObject != null) {
                                spanObject.innerHTML = SectionEIData + text[0];// + ', ' + text[3];
                                window.infotp2formulaeditor_left.ClearAttributes(spanObject);
                                /*
                                spanObject.removeAttribute('attrdescr-tiid');
                                spanObject.removeAttribute('attrdescr-contrtiid');
                                spanObject.removeAttribute('attrdescr-formula_un');
                                spanObject.removeAttribute('attrdescr-channel');
                                */
                                spanObject.setAttribute('attrdescr-sectiondataid', text[1]);
                                spanObject.setAttribute('attrdescr-channel', text[2]);
                            }
                        }
                    }
                });
                this.onChangeFormula();
            }
            catch (exc) {
                console.log(exc);
            }
        },

        onChangeFormula() {

            var tabMathView = document.querySelector("label[id*='_tformulaviewmathtab_label'");
            if (tabMathView != null) tabMathView.setAttribute("data-loaded", "False");

            var tabCalcView = document.querySelector("label[id*='_tformulaviewcalctab_label'");
            if (tabCalcView != null) tabCalcView.setAttribute("data-loaded", "False");

            var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
            var dictDescNew = new Object();
            var rows = table.querySelectorAll("tr[data-rid]");
            rows.forEach(function (tr) {
                var number = tr.getAttribute("data-rid");
                if (!dictDescNew[number])
                    dictDescNew[number] = {};
                dictDescNew[number].Formula_UN = document.querySelector("input[name='formula_un']").value;
                dictDescNew[number].stringnumber = number;
                dictDescNew[number].operBefore = tr.querySelector("span[data-spanoperbefore]").innerText;
                dictDescNew[number].operAfter = tr.querySelector("span[data-spanoperafter]").innerText;
                if (tr.querySelector("span[attrdescr-tiid]") != null)
                    dictDescNew[number].TI_ID = tr.querySelector("span[attrdescr-tiid]").getAttribute("attrdescr-tiid");
                if (tr.querySelector("span[attrdescr-contrtiid]") != null)
                    dictDescNew[number].ContrTI_ID = tr.querySelector("span[attrdescr-contrtiid]").getAttribute("attrdescr-contrtiid");
                if (tr.querySelector("span[attrdescr-formula_un]") != null)
                    dictDescNew[number].UsedFormula_UN = tr.querySelector("span[attrdescr-formula_un]").getAttribute("attrdescr-formula_un");
                if (tr.querySelector("span[attrdescr-channel]") != null)
                    dictDescNew[number].ChannelType = tr.querySelector("span[attrdescr-channel]").getAttribute("attrdescr-channel");
                //Section
                if (tr.querySelector("span[attrdescr-iscontract]") != null)
                    dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontract]").getAttribute("attrdescr-iscontract");
                if (tr.querySelector("span[attrdescr-iscontractclause]") != null)
                    dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontractclause]").getAttribute("attrdescr-iscontractclause");
                if (tr.querySelector("span[attrdescr-sectionid]") != null)
                    dictDescNew[number].ei_Section_ID = tr.querySelector("span[attrdescr-sectionid]").getAttribute("attrdescr-sectionid");
                if (tr.querySelector("span[attrdescr-sectiondataid]") != null)
                    dictDescNew[number].EI_SECTION_DATA_ID = tr.querySelector("span[attrdescr-sectiondataid]").getAttribute("attrdescr-sectiondataid");
            });

            document.querySelector("input[name='formulajson']").value = JSON.stringify(dictDescNew);
        },
    }
    return instance;
}();
